// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { ActionSheetContext, Button, Card, Illustration, LgPadding } from '@alto/design-system';
import React, { useContext } from 'react';
import savingsCardImage from '~shared/assets/images/savings_card.png';
import { type Prescription } from '~shared/types';
import { CouponAttestationActionSheet } from './CouponAttestationActionSheet';

type Props = {
  prescription: Prescription;
};

export const CouponCard = ({ prescription }: Props) => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);

  const handleAddCoupon = () => {
    setActiveActionSheet(<CouponAttestationActionSheet prescription={prescription} />);
  };

  return (
    <Card
      title="Save with a copay card"
      description={`Get ${prescription.medication_name || 'your medication'} for as little as $0 by adding a copay card`}
      RightContent={
        <Illustration
          size="lg"
          source={savingsCardImage}
          accessibilityLabel="discount"
        />
      }
      style={{ backgroundColor: COLORS.BACKGROUND_COLORS.SECONDARY_LIGHTEST }}
    >
      <LgPadding>
        <Button
          label="Add copay card"
          type="secondary"
          width="inline"
          small
          onPress={handleAddCoupon}
        />
      </LgPadding>
    </Card>
  );
};
